module.exports = __webpack_public_path__ + "static/media/hat-sri-lanka.c87f664d.png";